import React, { useState } from "react";
import "./Logout_Offcanvas.css";
import { Form, Offcanvas } from "react-bootstrap";
import Black_Btn from "../../common_components/common_btn/Black_Btn/Black_Btn";
import Gray_Btn from "../../common_components/common_btn/gray_btn/Gray_Btn";
import { useDispatch } from "react-redux";
import { getAllCart } from "../../../features/cart/cartSlice";
import { setIsSignedOut } from "../../../features/auth/authSlice";
import Cookies from "js-cookie";
import Success_Modal from "../../common_components/common_modal/success_modal/Success_Modal";
import { useNavigate } from "react-router-dom";

const Logout_Offcanvas = ({
  show,
  onHide,
  selectedOption,
  setSelectedOption,
  ...props
}) => {
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const navigate = useNavigate()

  const handleLogout = async () => {
    onHide()
    setShowSucsessModal(true);
    setTimeout(() => {
      setShowSucsessModal(false);
      navigate("/")
    }, 3000);
    await dispatch(getAllCart(props?.isSignIn));
    Cookies.remove("magistic_matress_security");
    dispatch(setIsSignedOut());
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={onHide}
        className="sort_offcanvas Logout_Offcanvas"
        placement="end"
      >
        <Offcanvas.Header>
          <div className="logo_div">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
              className="logo"
            />
          </div>
          <div className="close_div" onClick={onHide}>
            <img
              src="/assets/images/icons/close_white.png"
              className="close_img"
            />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="inner_div">
            <p className="title_text">Log Out</p>

            <div className="bottom_div">
              <p className="botttom_text">Are you sure,</p>{" "}
              <p className="botttom_text">you want to Log Out?</p>
              <div className="btn_holder">
                <Black_Btn btnText={"Yes"} onClick={handleLogout} />
                <Gray_Btn btn_name="No" onClick={onHide} />
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Logged out successfully"
      />
    </>
  );
};

export default Logout_Offcanvas;
